import { DashboardLayout } from "@/components/dashboard-layout";
import { Card, CardContent } from "@/components/ui/card";
import { ContextUser, getNextRedirectRoute } from "@/lib/utils";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/401")({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    const user = context.user as ContextUser;
    const noPermissions = getNextRedirectRoute(user) === "/401";
    //Only users without permissions should see this page. If they do have permissions, they should be redirected to the appropriate page.
    if (!noPermissions) {
      const nextRedirectRoute = getNextRedirectRoute(user);
      throw redirect({ to: nextRedirectRoute });
    }
  },
});

function RouteComponent() {
  return (
    <DashboardLayout submenu={null}>
      <Card>
        <CardContent>
          <p className="text-md pb-20 pt-15 text-center">
            You have logged in with an account that does not have permission to access any pages in the application.
            Please contact your administrator to be granted access.
          </p>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
